import MultiSelectPage from "@components/MultiSelectPage"

const OPTIONS = [
  "injuryOrHealth",
  "workAndPersonalLife",
  "slowerMetabolism",
  "stressOrMentalHealth",
  "medication",
  "other",
] as const

export default function WeightGainCauses() {
  return <MultiSelectPage translationKey="weightGainCauses" options={OPTIONS} />
}
